import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators, Dispatch, Action } from 'redux'
import { IApplicationState } from '../../rootReducer'
import Sidebar from '@SiteContainers/Sidebar'
import GuidelinesForm from '@SiteComponents/GuidelinesForm'
import Forwarder from '@SiteContainers/Forwarder'

import {
  IGuideline,
  ICreateGuidelinePayload,
  IUpdateGuidelinePayload,
  IDeleteGuidelinePayload,
  IUpdateDefaultGuidelinePayload,
  IDeleteDefaultGuidelinePayload,
  IFetchGuidelinesPayload,
} from '@SiteModules/Guideline/types'

import {
  fetchGuidelines,
  createGuideline,
  updateGuideline,
  deleteGuideline,
  updateDefaultGuideline,
  deleteDefaultGuideline,
} from '@SiteModules/Guideline/actions'

import {
  getCaptionGuidelines,
  getTranslationGuidelines,
} from '@SiteModules/Guideline/selectors'

import './Guidelines.scss'

interface GuidelinesProps {
  readonly captionGuidelines: IGuideline[]
  readonly translationGuidelines: IGuideline[]
  readonly hasLoadedInitially: boolean
  readonly loading: boolean
  readonly modifying: boolean
  readonly currentWorkspaceId: number
  fetchGuidelines(payload: IFetchGuidelinesPayload): void
  createGuideline(payload: ICreateGuidelinePayload): void
  updateGuideline(payload: IUpdateGuidelinePayload): void
  deleteGuideline(payload: IDeleteGuidelinePayload): void
  updateDefaultGuideline(payload: IUpdateDefaultGuidelinePayload): void
  deleteDefaultGuideline(payload: IDeleteDefaultGuidelinePayload): void
}

interface GuidelinesState {}

class Guidelines extends React.Component<GuidelinesProps, GuidelinesState> {
  componentDidMount() {
    if (this.props.currentWorkspaceId >= 0 && !this.props.hasLoadedInitially) {
      this.props.fetchGuidelines({ workspaceId: this.props.currentWorkspaceId })
    }
  }

  componentDidUpdate(prevProps: GuidelinesProps) {
    if (prevProps.currentWorkspaceId !== this.props.currentWorkspaceId && this.props.currentWorkspaceId >= 0 && !this.props.hasLoadedInitially) {
      this.props.fetchGuidelines({ workspaceId: this.props.currentWorkspaceId })
    }
  }

  render() {
    const {
      captionGuidelines,
      translationGuidelines,
      loading,
      modifying,
    } = this.props

    return (
      <React.Fragment>
        <Forwarder />
        <div className="Guidelines">
          <Sidebar
            pageName="guidelines"
          />
          <div className="Guidelines__main">
            <div className="Guidelines__title">
              Guidelines
            </div>
            <div className="Guidelines__subtitle">
              Improve and adapt your subtitles according to your needs.
            </div>
            {this.props.hasLoadedInitially && (
              <GuidelinesForm
                captionGuidelines={captionGuidelines}
                translationGuidelines={translationGuidelines}
                loading={loading}
                modifying={modifying}
                createGuideline={this.props.createGuideline}
                updateGuideline={this.props.updateGuideline}
                deleteGuideline={this.props.deleteGuideline}
                updateDefaultGuideline={this.props.updateDefaultGuideline}
                deleteDefaultGuideline={this.props.deleteDefaultGuideline}
                currentWorkspaceId={this.props.currentWorkspaceId}
              />
            )}
          </div>
        </div>
      </React.Fragment>
    )
  }
}

function mapStateToProps(state: IApplicationState) {
  const { guidelines, workspaces } = state

  return {
    captionGuidelines: getCaptionGuidelines(state),
    translationGuidelines: getTranslationGuidelines(state),
    hasLoadedInitially: guidelines.hasLoadedInitially,
    loading: guidelines.loading,
    modifying: guidelines.modifying,
    currentWorkspaceId: workspaces.currentWorkspaceId,
  }
}

function mapDispatchToProps(dispatch: Dispatch<Action>) {
  return bindActionCreators({
    fetchGuidelines,
    createGuideline,
    updateGuideline,
    deleteGuideline,
    updateDefaultGuideline,
    deleteDefaultGuideline,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Guidelines)
